import React from "react";
import styles from "./ReferralPage.css";
import PropTypes from "prop-types";
import NewsletterSubscribeForm from "../../components/Library/NewsletterSubscribeForm";
import FetchOnSubmit from "../../components/Library/FetchOnSubmit";
import validateEmail from "../../utils/validateEmail";

export default function LandingPage({
  updateSubmitted,
  referralCode,
  referralVars,
}) {
  return (
    <div className={styles.root}>
      <div className={`${styles.landing}`}>
        <div className={styles.content}>
          <h1 dangerouslySetInnerHTML={{ __html: referralVars.header }} />
          <p>{referralVars.descriptionSnippet}</p>
          <FetchOnSubmit
            method="POST"
            url="/refer/send_optin/"
            onSuccess={() => updateSubmitted(true)}
            validate={validateEmail}
          >
            {({ status, error, submit, reset }) => {
              return (
                <NewsletterSubscribeForm
                  formClassName="referral-form"
                  list={""}
                  submit={({ email }) =>
                    submit({
                      email,
                      referred_to_list: referralVars.newsletterName,
                      referred_by: referralCode,
                    })
                  }
                  status={status}
                  error={error}
                  reset={reset}
                  placeholder={"Your Email Address"}
                  userVars={{}}
                  submitButtonText="Subscribe"
                  additionalClass={styles[referralVars.style]}
                />
              );
            }}
          </FetchOnSubmit>
          <a href={referralVars.href} target="_blank" className={styles.link}>
            Want a sneak peak? Read the latest version here.
          </a>
        </div>
        <div className={styles.image}>
          <img
            src={require("assets/" + referralVars.mobileImage)}
            alt={referralVars.mobileImageHint}
          />
        </div>
      </div>
    </div>
  );
}

LandingPage.propTypes = {
  referralCode: PropTypes.string.isRequired,
  updateSubmitted: PropTypes.func.isRequired,
  referralVars: PropTypes.shape({
    name: PropTypes.string,
    newsletterName: PropTypes.string,
    href: PropTypes.string,
    descriptionSnippet: PropTypes.string,
    mobileImage: PropTypes.string,
    mobileImageHint: PropTypes.string,
    style: PropTypes.string,
  }),
};
